import React, { Component } from 'react';
import Button from './Button';
import apiInstance from './apiInstance';
import InstallPopup from './InstallPopup';
import DeletePopup from './DeletePopup';
import InstalledSitesPopup from './Popups/InstalledSitesPopup';
import { formatDate } from './Functions/formatDate';

class Widget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            widgets: [],
            deletePopup: React.createRef(),
            installPopup: React.createRef(),
            sitePopup: React.createRef()
        };
    }

    componentDidMount() {

        apiInstance.get('/widget/')
            .then(response => {
                this.setState({ widgets: response.data });
                // console.log(response.data )
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    deleteWidget = (widgetId) => {
        let updatedWidgets = this.state.widgets.filter((widget) => widget.id !== widgetId);

        this.setState((prevState) => {
            return({
                ...prevState,
                widgets: updatedWidgets
            })
        })
    }

    updateWidgetSites = (widgetId, sites) => {
        let updatedWidgets = this.state.widgets.map((widget) => {
            if (widget.id === widgetId) {
                widget.sites = sites;
            }
            return widget;
        });

        this.setState((prevState) => {
            return({
                ...prevState,
                widgets: updatedWidgets
            })
        })
    }

    render() {
        let { widgets, deletePopup, installPopup, sitePopup } = this.state;
        function getWidgetSrc(imageSrc,name,type){
            if (imageSrc) {
              return imageSrc.startsWith("devadmin")
                ? `${process.env.REACT_APP_SERVER_URL}/${imageSrc}?ts=${Date.now()}`
                : `${imageSrc}?ts=${Date.now()}`;
            }
            return `/images/${name}-${type}.png`;
          };
        return (
            <>
                <div className="mjwi-user-widgets-banner"><Button name="Add a New Widget" href={'/catalog'} /></div>
                <div className="mjwi-ct-list mjwi-row">
                    {widgets.map(widget => (
                        <div key={widget.id} className="mjwi-ct-card">
                            <div className="mjwi-ct-card-banner">
                                {/* <img src={"/images/" + widget.widgetType.name + '-banner.png'} className="mjwi-catalog-banner" /> */}
                            </div>
                             <div className="mjwi-ct-card-logoname">
                                <img 
                                    src={getWidgetSrc(widget.widgetType.iconImage,widget.widgetType.name,"logo")} 
                                    className="mjwi-catalog-logo" 
                                    onError={(e) => {
                                        if (!e.target.src.includes("Default-Widget-Logo.png")) {
                                            e.target.onerror = null;
                                            e.target.src = "/images/Default-Widget-Logo.png";
                                        }
                                    }}
                                    alt="Widget Logo"
                                />
                                <h3 className="mjwi-ct-card__title">{widget.widgetType.name}</h3>
                                <span 
                                    onClick={() => { 
                                        sitePopup.current.openPopup(widget.id, widget?.sites || []); 
                                    }}
                                    className='mjwi-site-logo'>
                                    {widget?.sites?.length || 0}
                                    <i class="fa-solid fa-globe"></i>
                                </span>
                            </div>
                            <div className="mjwi-ct-card-desc">
                                <span className="mjwi-widget-title">
                                    <p class="mjwi-ct-card__content">Widget Name: {widget.title}</p>
                                </span>
                                <span className="mjwi-widget-title">
                                    <p class="mjwi-ct-card__content">Next Renewal: {widget.expires ? formatDate(widget.expires) : 'N/A'}</p>
                                </span>
                                <span className="mjwi-widget-status">
                                    <p class="mjwi-ct-card__content">Status: {widget?.subStatus || 'N/A'}</p>
                                </span>
                                <span className="mjwi-widget-text">
                                    {widget.text}
                                </span>
                            </div>
                            <div className="mjwi-ct-card-btns">
                                <Button name="Edit" href={'/editor?widgetId=' + widget.id} />
                                <Button name="Install" eventHandler={() => {installPopup.current.openPopup(widget, widget.widgetType.name)}} />
                                <Button name="Delete" eventHandler={() => {deletePopup.current.openPopup(widget.id)}} />
                            </div>
                        </div>
                    ))}
                </div>
                <DeletePopup ref={deletePopup} deleteWidgetHandler = {this.deleteWidget}/>
                <InstallPopup ref={installPopup}/>
                <InstalledSitesPopup ref={sitePopup} updateWidgetSites = {this.updateWidgetSites}/>
            </>
        );
    }
}


export default Widget;
